import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ScrollService } from '../../core/scroll.service';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';


@Component({
  selector: 'view-create-account',
  templateUrl: './view-create-account.component.html',
  styleUrls: ['./view-create-account.component.scss']
})
export class ViewCreateAccountComponent implements OnInit {

  public breadcrumb = [];
  public isFormValidated:boolean;
  public isFormFailed:boolean;

  public formGroup = new FormGroup({
    invitationCode: new FormControl(),
    givenName: new FormControl(),
    surname: new FormControl(),
    phoneNumber: new FormControl(),
    emailAddress: new FormControl(),
    emailAddressAlt: new FormControl(),
    password: new FormControl(),
    passwordConfirm: new FormControl(),
  })

  constructor(
    private loginGuard: LoginGuardService, // 
    private lang: LangService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private scrollService: ScrollService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.deactivate();
    this.scrollService.scrollToTop();
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_create_account'), this.router.url),
    ];
  }

  isPasswordPolicyShowing:boolean;
  togglePasswordPolicy(){
    this.isPasswordPolicyShowing = !this.isPasswordPolicyShowing;
  }

  submitForm(){
    // this.scrollService.scrollToTop();
    // this.isFormValidated = true;
    this.isFormFailed = true;
  }

}
